import { render, staticRenderFns } from "./ProductCoupons.vue?vue&type=template&id=ec019338&"
import script from "./ProductCoupons.vue?vue&type=script&lang=js&"
export * from "./ProductCoupons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports